// extracted by mini-css-extract-plugin
export default {"main":"TopRelationships_main__P9WG7","sidebarLegend":"TopRelationships_sidebarLegend__OQvt0","graph":"TopRelationships_graph__LP2Ty"};